// extracted by mini-css-extract-plugin
module.exports = {"txtBlock":"course-osteo_txtBlock__AmxEi","uniqPointsBlock":"course-osteo_uniqPointsBlock__cI5Pw","consultButton":"course-osteo_consultButton__RvnoJ"};